module.exports = __webpack_public_path__ + "img/img_coupon_internet_full.a5889567.png";